import React from "react";
import { FormattedHTMLMessage, injectIntl } from "react-intl";

const InjectMessageWithHTML = (props) => <FormattedHTMLMessage {...props} />;

export default injectIntl(InjectMessageWithHTML, {
  withRef: false,
});
